export default "__VITE_ASSET__D2u3W_xK__"